'use client';

import { useLocalStorage, dispatchStorageEvent } from './useLocalStorage';
import { TOKEN_KEY } from '@/constants/auth';

export { TOKEN_KEY };

export function useJWT() {
  return useLocalStorage<string | null>(TOKEN_KEY, null, {
    serializer: (value) => value ?? '',
    deserializer: (value) => (value === '' ? null : value)
  });
}

export function useHasJWT(): boolean {
  const [jwt] = useJWT();
  return !!jwt;
}

export function notifyJWTChange(): void {
  dispatchStorageEvent(TOKEN_KEY);
}
